import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from '@angular/forms';
import { DetailsComponent } from './details.component';
import { DetailsRoutingModule } from './details.routes';
import { BookingComponent } from './booking/booking.component';
import { InquiryComponent } from './inquiry/inquiry.component';
import { DetailsService } from './details.service';
import { BookingService } from './booking/booking.service';
import { InquiryService } from './inquiry/inquiry.servvice';
import { SharedModule } from '../shared-components/shared.module';

import { NgxMyDatePickerModule } from 'ngx-mydatepicker';

import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpModule } from '@angular/http';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../../assets/i18n', '.json');
}

@NgModule({
  imports: [
    CommonModule, DetailsRoutingModule, FormsModule, BrowserAnimationsModule, SharedModule,
     NgxMyDatePickerModule.forRoot(), TranslateModule.forRoot(), HttpModule
  ],
  declarations: [DetailsComponent, BookingComponent, InquiryComponent],
  providers: [DetailsService, BookingService, InquiryService],
  exports: [DetailsComponent]
})
export class DetailsModule { }



// WEBPACK FOOTER //
// ./src/app/details/details.module.ts